import { AdvancedFilterInputSchema } from "@redotech/redo-fulfillment-common/fulfillment-group-summary-input";
import * as z from "zod";

export const rerunAutomationsForView = {
  name: "rerunAutomationsForView" as const,
  input: AdvancedFilterInputSchema.extend({
    expectedCount: z.number().int().nonnegative(),
  }),
  output: z.object({ success: z.boolean(), error: z.string().nullish() }),
};
